module.exports = __webpack_public_path__ + "static/media/iconsCategory.fe556d69.svg";